<div class="w-full overflow-x-auto">
  @if (loading) {
  <div class="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden p-4">
    <div class="animate-pulse">
      <div class="flex gap-3 mb-3 border-b border-slate-100 pb-3">
        <div class="h-4 bg-slate-200 rounded w-28"></div>
        @for (col of columns; track col) {
        <div class="h-4 bg-slate-200 rounded flex-1"></div>
        }
      </div>
      @for (row of skeletonRows; track row) {
      <div class="flex gap-3 mb-2">
        <div class="h-4 bg-slate-200 rounded w-28"></div>
        @for (col of columns; track col) {
        <div class="h-4 bg-slate-100 rounded flex-1"></div>
        }
      </div>
      }
    </div>
  </div>
  } @else {
  <div class="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden">
    <table class="w-full">
      <thead>
        <tr class="bg-[#f9fafb]">
          <th class="text-left text-[11px] font-extrabold text-slate-500 px-4 py-3">{{ rowHeader }}</th>
          @for (col of columns; track col) {
          <th class="text-center text-[11px] font-extrabold text-slate-500 px-3 py-3">{{ col }}</th>
          }
        </tr>
      </thead>
      <tbody>
        @for (row of rows; track $index) {
        <tr class="border-t border-slate-100 hover:bg-[#f9fafb]">
          <td class="px-4 py-2 text-[12px] font-semibold text-slate-800 whitespace-nowrap">{{ row.label }}</td>
          @for (cell of row.cells; track $index) {
          <td class="px-3 py-2 text-center">
            @if (cell.tone) {
            <span
              class="inline-flex min-w-[52px] justify-center rounded-md px-2 py-1 text-[11px] font-extrabold text-white"
              [ngClass]="toneClass[cell.tone]"
            >
              {{ cell.value }}
            </span>
            } @else {
            <span class="font-bold text-[12px] text-slate-800">{{ cell.value }}</span>
            }
          </td>
          }
        </tr>
        }
      </tbody>
    </table>
  </div>
  }
</div>
